import { ENTITY_TYPES } from "../../../Constants";

export const NEW_ENTITY_TYPES = [
  ENTITY_TYPES[0],
  { value: "individual", name: "Individual" },
  ...ENTITY_TYPES.splice(1,ENTITY_TYPES.length-1),
];
